module.exports = __webpack_public_path__ + "img/save.7d3c6886.svg";